import React from 'react';
import './FormComponents.scss';

const FileInput = ({
  id,
  name,
  label,
  onChange,
  accept = '',
  multiple = false,
  required = false,
  disabled = false,
  className = '',
  placeholder = 'Choose file...',
  ...props
}) => {
  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}
      <input
        type="file"
        id={id}
        name={name}
        onChange={onChange}
        accept={accept}
        multiple={multiple}
        className="form-input file-input"
        required={required}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

export default FileInput;